import { render, staticRenderFns } from "./TableHeaderFile.vue?vue&type=template&id=2fcd636a&scoped=true"
import script from "./TableHeaderFile.vue?vue&type=script&lang=js"
export * from "./TableHeaderFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd636a",
  null
  
)

export default component.exports